import { ChatLogoCvna } from '@carvana/ds-icons';
import React from 'react';
import LinkButton from '|/components/carvana-ds/link-button';
import styles from './support-contact-link.module.css';
import useSupportContactClick from './use-support-contact-click';

interface SupportContactLinkProps {
  onClick: () => void;
  onClose?: () => void;
}

/** Text-link form of Support & Contact, as opposed to the filled `SupportContact` button. */
const SupportContactLink: React.FC<SupportContactLinkProps> = ({ onClick, onClose }) => {
  const handleClick = useSupportContactClick({ onClick, onClose });

  return (
    <LinkButton
      size="sm"
      underline={false}
      className={styles.supportLink}
      onClick={handleClick}
      data-analytics-id="pp_header_support_contact"
    >
      <ChatLogoCvna size={16} color="currentColor" aria-hidden />
      <span>Support &amp; Contact</span>
    </LinkButton>
  );
};

export default SupportContactLink;
